const isProduction = (): boolean => window.location.hostname.startsWith('www.westwing.');

export const getShopStaticCmsHost = (): string =>
    isProduction() ? 'https://static.westwingnow.de/' : 'https://static-stage-release-shop1.westwing.eu/';
